import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-templating';
import { DynamicFieldMeta } from '~/components/dynamic-field-table/dynamic-field-table';
import { FormModel } from '~/models/form-model';

enum REDEMPTION_FIELD {
	INVEST_MGR_FIELD = 'T4z_SwitchingIMgrs',
	BALANCE_FIELD = 'T4f_From_Cash_Bal',
	NBR_OF_UNITS_FIELD = 'T4f_From_Unit_Bal',
	TYPE_FIELD = 'T4z_Model_No',
	PEND_ASSETS_FIELD = 'T4z_Pending_Assets',
	METHOD_FIELD = 'T4z_Method',
	AMT_TO_TAKE_FIELD = 'T4f_Switching_From',
}

enum REDEMPTION_FIELD_HEADERS {
	INVEST_MGR_FIELD_HEADERS = 'Invest Mgr',
	BALANCE_FIELD_HEADERS = 'Balance',
	NBR_OF_UNITS_FIELD_HEADERS = 'Nbr of Units',
	TYPE_FIELD_HEADERS = 'Type',
	PEND_ASSETS_FIELD_HEADERS = 'Pend Assets',
	METHOD_FIELD_HEADERS = 'Method',
	AMT_TO_TAKE_FIELD_HEADERS = 'Amt to Take',
}

export interface OptionalFields {
	[fieldName: string]: { show: boolean; label: string };
}

export interface FormInitData {
	optionalFields: OptionalFields;
	unitCodeLabel: string;
}

@autoinject
export class RedemptionFields {
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private editMode: boolean = true;

	@bindable({
		defaultBindingMode: bindingMode.toView,
		changeHandler: 'formModelChanged',
	})
	protected formModel: FormModel;

	private readonly dynamicFieldMaxSize: number = 15;

	private readonly hideRowControls: boolean = true;

	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private dynamicFieldMeta: DynamicFieldMeta[];

	private formModelChanged(
		formModel: FormModel,
		oldFormModel: FormModel,
	): void {
		const conditionalFields: DynamicFieldMeta[] = [];
		if (formModel.fields.T4z_Model_No01.visible) {
			conditionalFields.push({
				fieldNamePrefix: REDEMPTION_FIELD.TYPE_FIELD,
				header: REDEMPTION_FIELD_HEADERS.TYPE_FIELD_HEADERS,
				fieldType: 'text',
			});
		}

		this.dynamicFieldMeta = [
			{
				fieldNamePrefix: REDEMPTION_FIELD.INVEST_MGR_FIELD,
				header: REDEMPTION_FIELD_HEADERS.INVEST_MGR_FIELD_HEADERS,
				fieldType: 'text',
			},
			{
				fieldNamePrefix: REDEMPTION_FIELD.BALANCE_FIELD,
				header: REDEMPTION_FIELD_HEADERS.BALANCE_FIELD_HEADERS,
				fieldType: 'number',
			},
			{
				fieldNamePrefix: REDEMPTION_FIELD.NBR_OF_UNITS_FIELD,
				header: REDEMPTION_FIELD_HEADERS.NBR_OF_UNITS_FIELD_HEADERS,
				fieldType: 'number',
			},
			...conditionalFields,
			{
				fieldNamePrefix: REDEMPTION_FIELD.PEND_ASSETS_FIELD,
				header: REDEMPTION_FIELD_HEADERS.PEND_ASSETS_FIELD_HEADERS,
				fieldType: 'text',
			},
			{
				fieldNamePrefix: REDEMPTION_FIELD.METHOD_FIELD,
				header: REDEMPTION_FIELD_HEADERS.METHOD_FIELD_HEADERS,
				fieldType: 'select',
			},
			{
				fieldNamePrefix: REDEMPTION_FIELD.AMT_TO_TAKE_FIELD,
				header: REDEMPTION_FIELD_HEADERS.AMT_TO_TAKE_FIELD_HEADERS,
				fieldType: 'number',
			},
		];
	}
}
